import { render, staticRenderFns } from "./Gauages.vue?vue&type=template&id=49a807a5&scoped=true&"
import script from "./Gauages.vue?vue&type=script&lang=js&"
export * from "./Gauages.vue?vue&type=script&lang=js&"
import style0 from "./Gauages.vue?vue&type=style&index=0&id=49a807a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a807a5",
  null
  
)

export default component.exports